import { Dialog } from '@angular/cdk/dialog';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientService, IsoService } from '@core/services';
import {
  OiqFormCheckboxComponent,
  OiqFormInputComponent,
  OiqFormTextComponent,
} from '@oiq-ui-sdk/form';
import { OiqUiAlertDialogService } from '@oiq-ui-sdk/ui';
import { AddSalesRepDialogService } from '@v2/modules/applications/add-application/components/add-sales-rep-dialog/add-sales-rep-dialog.component';
import { OiqIsoSearchComponent } from '@v2/modules/isos/components/iso-search/iso-search.component';
import { OiqIsoSalesRepSelectComponent } from '@v2/modules/isos/components/sales-rep-select/sales-rep-select.component';
import { OiqClientCreateForm } from './client-form';

@Component({
  selector: 'oiq-client-create-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    OiqFormInputComponent,
    OiqFormCheckboxComponent,
    OiqIsoSearchComponent,
    AsyncPipe,
    OiqIsoSalesRepSelectComponent,
    OiqFormTextComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OiqClientCreateFormComponent {
  event = output<{ type: any; data?: any }>();
  showBackButton = input<boolean>(false);
  configuration = input<{
    whiteLabels?: any[];
    whiteLabelId: number;
  }>({
    whiteLabels: [],
    whiteLabelId: null,
  });

  private _clients = inject(ClientService);
  private _isos = inject(IsoService);
  private _salesRepCreateDialog = inject(AddSalesRepDialogService);

  formRef = new OiqClientCreateForm(this._clients, this._isos);
  createIso = false;

  private ocrPrefilled: { [key: string]: boolean } = {};

  constructor(
    private dialog: Dialog,
    private alert: OiqUiAlertDialogService
  ) {
    effect(() => {
      const _configuration = this.configuration();
      if (!_configuration) {
        return;
      }
      this.formRef.configuration = _configuration;
    });
  }

  addSalesRep(): void {
    const isoId = this.formRef.get('isoId').value;
    this._salesRepCreateDialog.open({ isoId: isoId }).subscribe(result => {
      if (!result?.data?.id) {
        return;
      }
      this.formRef.reloadIsoUsers();
      this.formRef.patchValue({
        isoSalesRepresentativeId: result.data.id,
      });
    });
  }

  isOcrPrefilled(field: string): boolean {
    return this.ocrPrefilled[field] || false;
  }

  onBackClicked(): void {
    this.event.emit({ type: 'back_clicked' });
  }

  public formatSalesRepName(_item): string {
    return _item.firstName + ' ' + _item.lastName;
  }
}
